import useSWRImmutable from 'swr/immutable';
import { api, BASE_API_URL } from '@/src/utils/api';
import { ApiUrls } from '@/data/superstack/ApiUrls';

function useSidos() {
  const fetcher = async (...args) =>
    api.get(...args).then((res) => {
      return res;
    });
  const { data, error, mutate } = useSWRImmutable(
    BASE_API_URL + ApiUrls().find((url) => url.name === 'ss_all_sido_view').url,
    fetcher,
    {
      shouldRetryOnError: false,
    },
  );
  return {
    addresses: data && data.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}

function useSigungus() {
  const fetcher = async (...args) =>
    api.get(...args).then((res) => {
      return res;
    });
  const { data, error, mutate } = useSWRImmutable(
    BASE_API_URL + ApiUrls().find((url) => url.name === 'ss_all_sigungu_view').url,
    fetcher,
    {
      shouldRetryOnError: false,
    },
  );
  return {
    addresses: data && data.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}

function useSidoSigungus() {
  const fetcher = async (...args) =>
    api.get(...args).then((res) => {
      return res;
    });
  const { data, error, mutate } = useSWRImmutable(
    BASE_API_URL + ApiUrls().find((url) => url.name === 'ss_all_address_kor').url,
    fetcher,
    {
      shouldRetryOnError: false,
    },
  );
  return {
    addresses: data && data.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}

export { useSidos, useSigungus, useSidoSigungus };
